<template>
  <div class="activity_my_entries_container">
    <div class="back">
      <span class="back-arrow" @click="$router.back(-1)">
        <Icon iconClass="arrow-left2" />
      </span>
      <span>我的作品</span>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="activity_my_entries_box">
      <van-list v-model="loading" :offset="10" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
        <ul class="my_entries_list">
          <li class="my_entries_item" v-for="(item,index) in entriesList" :key="index" @click="toEntriyDetail(item)">
            <div class="entries_text">
              <div class="entriy_title" v-text="item.applyFormTitle"></div>
              <div class="entriy_info">
                <span class="status approved" v-if="item.applyFormStatus==1">审核通过</span>
                <span class="status rejected" v-else-if="item.applyFormStatus==2">审核驳回</span>
                <span class="status submitted" v-else>未审核</span>
                <span class="type_list">
                  <Icon iconClass="circle-text" />
                  <Icon iconClass="circle-picture" v-if="item.pictures.length>0" />
                  <Icon iconClass="listen" v-if="item.video.length>0" />
                  <Icon iconClass="play" v-if="item.video.length>0" />
                </span>
                <span class="vote">
                  <span v-if="item.applyFormStatus==1">
                    <van-icon name="like-o" />{{item.supportCount}}票
                  </span>
                </span>
              </div>
              <div class="rejected_reason" v-if="item.applyFormStatus==2">
                原因：{{item.unAuditReason}}
              </div>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>

</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import activityApi from "@/api/apis/activity.js";
import commApi from "@/api/apis/common.js";
export default {
  name: "MyEntries",
  data() {
    return {
      activityParams: {
        contentType: 1,
        activityId: null,
        cId: 0,
      },
      activityDetail: null,
      refreshing: false,
      loading: false,
      finished: false,
      params: {
        activityId: null,
        sortType: 1,
        pageNo: 0,
        pageSize: 10,
        memberId: null,
      },
      entriesList: [],
      entriesTotal: 0,
      pageCount: 0,
      loadFirstPage: true, //是否加载第一页,用来解决vant上拉加载本身的缺陷问题
    };
  },
  computed: {
    ...mapState("app", ["userInfo","shareRootUrl"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;
      var url = _this.shareRootUrl + "/index_share?contentType=" + _this.activityParams.contentType + "&activityId=" + _this.activityParams.activityId + "&contentCode=" + _this.nodeCode;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: url
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.activityDetail.activityName + " - 法治号客户端", _this.activityDetail.description, url, _this.activityDetail.sharePictureUrl);
      }).catch((err) => {

      })
    },
    /* 获取活动详情 */
    getActivityDetail() {
      var _this = this;
      activityApi
        .getActivityDetail(_this.activityParams)
        .then((res) => {
          if (res.suc == 1) {
            _this.activityDetail = res.data;
            _this.wechatShare(); // 微信二次分享
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取参赛作品列表 */
    listApplyFormByMemberId() {
      var _this = this;

      activityApi
        .listApplyFormByMemberId(_this.params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            if (_this.params.pageNo == 0) {
              _this.entriesList = res.data.applyFormList;
            } else {
              _this.entriesList = _this.entriesList.concat(
                res.data.applyFormList
              );
            }
            _this.entriesTotal = res.data.count;
            _this.pageCount = Math.ceil(res.data.count / _this.params.pageSize);
            if (_this.params.pageNo >= _this.pageCount - 1) {
              _this.finished = true;
            }
            _this.loadFirstPage = false;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 下拉刷新 */
    onRefresh() {
      this.params.pageNo = 0;
      // this.listApplyFormByMemberId = [];
      this.activityTotal = 0;
      this.pageCount = 0;
      this.loadFirstPage = true;
      if (this.finished) {
        this.refreshing = false;
      } else {
        this.refreshing = true;
      }
      this.loading = false;
      this.finished = false;
      this.listApplyFormByMemberId();
    },
    /* 上拉加载 */
    onLoadMore() {
      if (!this.loadFirstPage) {
        this.params.pageNo++;
        if (this.params.pageNo < this.pageCount) {
          this.loading = true;
          this.listApplyFormByMemberId();
        }
      }
    },
    /* 跳转作品详情 */
    toEntriyDetail(data) {
      if (data.applyFormStatus == 1) {
        this.$router.push({
          path: "/entriy_detail",
          query: {
            applyFormId: data.applyFormId,
            contentType: "activity_work_detail",
          },
        });
      } else {
        this.$router.push({
          path: "/update_works",
          query: {
            activityId: this.params.activityId,
            applyFormId: data.applyFormId,
          },
        });
      }
    },
  },
  created() {
    document.title = "我的作品";
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "activityId")) {
      this.params.activityId = query.activityId;
      this.activityParams.activityId = query.activityId;
      this.getActivityDetail();
      if (!!this.userInfo) {
        this.params.memberId = this.userInfo.id;
      } else {
        this.$router.push("/login");
        return;
      }
      this.listApplyFormByMemberId();
      loadStat(); // 友盟统计
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.activity_my_entries_container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  .activity_my_entries_box {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #f6f6f6;
    .my_entries_list {
      padding: 25px 15px 15px;
      .my_entries_item {
        padding: 10px 15px;
        background-color: #fff;
        margin-bottom: 15px;
        border-radius: 8px;
        .entries_text {
          .entriy_title {
            max-height: 48px;
            margin-bottom: 5px;
            overflow: hidden;
            line-height: 24px;
            color: #222;
            font-size: 18px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .entriy_info {
            display: flex;
            flex-direction: row;
            line-height: 24px;
            .status {
              flex: 1;
              font-size: 14px;
              &.approved {
                color: #23d060;
              }
              &.submitted {
                color: #ebbe0b;
              }
              &.rejected {
                color: #d22d26;
              }
            }
            .type_list {
              flex: 1;
              .tj-svg-icon {
                margin-right: 5px;
                color: #999999;
                font-size: 16px;
                &.tj-icon-circle-text {
                  font-size: 18px;
                }
                &.tj-icon-circle-picture {
                  font-size: 15px;
                  vertical-align: -0.1em;
                }
                &.tj-icon-listen {
                  font-size: 18px;
                  vertical-align: -0.2em;
                }
                &.tj-icon-play {
                  font-size: 18px;
                }
              }
            }
            .vote {
              flex: 1;
              text-align: right;
              color: #397ef5;
              font-size: 12px;
            }
          }
          .rejected_reason {
            margin-top: 5px;
            line-height: 21px;
            padding: 5px 15px;
            background-color: #f5f5f5;
          }
        }
      }
    }
  }
}
</style>